module.exports = __webpack_public_path__ + "img/bc12e37948b72141146476302ad50a59.png";